// Bilingual (EN/FR) copy for the Advertise booking page (/advertise).
// Interpolated strings are functions; everything else is plain text.

export const PLACEMENT_PREVIEW_IMG = {
  home_top: "https://static.prod-images.emergentagent.com/jobs/0bb35e6b-e46a-4892-929f-72cf88d0a5d8/images/649e6b64c8feac4e708b34db696006ed536f9c0f960e290881c5e221b4e8668f.jpeg",
  home: "https://static.prod-images.emergentagent.com/jobs/0bb35e6b-e46a-4892-929f-72cf88d0a5d8/images/19cc6648f56750b7daa8d2b0c13a3fdf7b9c11343ecd144efdd9977e1cbc0c28.jpeg",
  browse: "https://static.prod-images.emergentagent.com/jobs/0bb35e6b-e46a-4892-929f-72cf88d0a5d8/images/abcb74a55e67600cec8eb2a7985c52671498b3eedb3946aea3376e71fb4b8fbb.jpeg",
  browse_bottom: "https://static.prod-images.emergentagent.com/jobs/0bb35e6b-e46a-4892-929f-72cf88d0a5d8/images/4125781dfdb5cf3b6e4ec9325e6c604c3974bbd50f203edb4b3f37a399b28062.jpeg",
  browse_sidebar: "https://static.prod-images.emergentagent.com/jobs/0bb35e6b-e46a-4892-929f-72cf88d0a5d8/images/fd14548af397034a72308a7f389ac95c956dd71bebec7e23189c5178f8eadb13.jpeg",
  listing: "https://static.prod-images.emergentagent.com/jobs/0bb35e6b-e46a-4892-929f-72cf88d0a5d8/images/fd14548af397034a72308a7f389ac95c956dd71bebec7e23189c5178f8eadb13.jpeg",
};

export const ADVERTISE_COPY = {
  en: {
    signin: "Please sign in to advertise.",
    gate_title: "Advertise on CritterPosts.ca",
    gate_body_1: "Banner advertising is available to ",
    gate_body_strong: "verified business",
    gate_body_2: " accounts. Set your account type to Business and get verified to start promoting your brand to thousands of Canadian pet lovers.",
    biz_account: "Business account",
    verified_seller: "Verified seller",
    go_dashboard: "Go to dashboard",
    header_title: "Advertise with us",
    header_sub_1: "Promote your business in banner slots across CritterPosts.ca. ",
    header_sub_price: (cur, rate) => `From ${cur} $${rate}/day`,
    header_sub_2: " — pay by Interac e-Transfer.",
    submit_h: "Submit a banner ad",
    ad_image: "Ad image",
    recommended_for: "Recommended for",
    uploading: "Uploading…",
    upload_creative: "Upload your banner creative",
    cropped_note: (lbl, size) => `Cropped to ${lbl} size (${size}). Use re-crop if you change placement.`,
    headline: "Headline (optional overlay)",
    headline_ph: "e.g. 20% off grooming this month",
    dest_link: "Destination link",
    dest_ph: "https://yourbusiness.ca or /seller/your-id",
    placement: "Placement",
    see_where: "See where it appears:",
    full_guide: "View the full placement guide →",
    run_len: "Run length (days)",
    save_longer: "Save more on longer runs: 10% off 14+ days, 20% off 30+ days.",
    pref_start: "Preferred start date (optional)",
    slot_avail: "Slot availability — pick an open slot for the most rotation",
    live_word: "live",
    promo: "Promo code (optional)",
    promo_ph: "e.g. SAVE25",
    apply: "Apply",
    coupon_applied: (code, d) => `✓ ${code} applied — extra ${d}% off`,
    est_cost: "Estimated cost",
    off: "off",
    code_suffix: "code",
    submit_btn: "Submit for approval",
    submit_bundle: "Submit bundle for approval",
    bundle_label: "Bundle placements",
    bundle_badge: (p) => `${p}% bundle`,
    bundle_hint: (n) => `Same banner across ${n} slots`,
    bundle_remove: "Remove",
    receipt_placements: "Placements",
    t_bundle_loaded: (n) => `Bundle loaded — add a link and book ${n} slots`,
    submit_note: "After submitting, send payment by Interac e-Transfer. Your ad goes live once we confirm payment.",
    receipt_h: "Ad submitted — payment needed",
    receipt_body_1: "Send an ",
    receipt_body_strong: "Interac e-Transfer",
    receipt_body_2: " to complete your booking. We'll approve your ad as soon as payment arrives.",
    send_to: "Send to",
    amount: "Amount",
    msg_ref: "Message / reference",
    runs: "Runs",
    include_ref_1: "Include the reference ",
    include_ref_2: " in the e-Transfer message so we can match your payment.",
    my_ads: "My ads",
    weekly_email: "Weekly performance email",
    no_ads: "You haven't submitted any ads yet.",
    untitled: "(untitled ad)",
    download_report: "Download report",
    rerun: "Re-run",
    extend: "Extend",
    crop_for: (lbl, size) => `Crop for ${lbl} — ${size}`,
    crop_desc: "Pan and zoom so your key content fills the frame. Your image saves at the exact slot size — no surprise cropping.",
    cancel: "Cancel",
    apply_crop: "Apply crop",
    where_appears: "Where it appears",
    my_banner: "My banner",
    upload_above: "Upload your ad image above and it will appear right in this slot.",
    crop_warn_1: "Your image is ",
    crop_warn_2: " — it'll be centre-cropped to fill this slot. Keep logos & text inside the dashed safe area, or upload ",
    crop_warn_3: " for a perfect fit.",
    fit_ok: (size) => `Great fit — your image matches this slot's ${size} shape. Keep key content inside the dashed safe area.`,
    rec_size: "Recommended image size:",
    price_word: "Price: ",
    per_day: "/day",
    per_day_for: (cur, amt, days) => ` · ${cur} $${amt} for ${days} day${days === 1 ? "" : "s"}`,
    close: "Close",
    choose_placement: "Choose this placement",
    rerun_campaign: "Re-run campaign",
    extend_campaign: "Extend campaign",
    renew_desc: (title) => `Book another run of "${title}". You'll get e-Transfer instructions and it goes live once payment is confirmed.`,
    cost: "Cost",
    book_renewal: "Book renewal",
    t_upload_img: "Please choose an image file",
    t_upload_first: "Upload your ad image first",
    t_add_link: "Add a destination link",
    t_renewal_booked: "Renewal booked — send payment to go live",
    t_code_applied: (d) => `Code applied — ${d}% off`,
    t_code_invalid: "That code isn't valid",
    t_weekly_on: "Weekly emails on",
    t_weekly_off: "Weekly emails off",
    t_banner_loaded: "Your banner is loaded — add a link and book",
    premium_badge: "Premium",
    scarcity: "Limited — only 1 premium slot",
    fullpage_title: "Own the whole Browse page",
    fullpage_body: (pct) => `Run your banner on both the top and bottom Browse strips and save ${pct}%.`,
    fullpage_btn: (pct) => `Bundle both strips — save ${pct}%`,
    preset_title: "Bundle & save",
    preset_hint: "Book multiple slots together and the discount applies automatically.",
    preset_browse: "Both Browse strips",
    preset_all: "Every slot",
    preset_save: (pct) => `save ${pct}%`,
    combo_name: "Homepage takeover",
    combo_tag: "full price",
    combo_badge: "Homepage takeover · full price",
    premium_perks: {
      title: "Why go Premium",
      items: [
        "Very top of the homepage — the first thing every visitor sees",
        "Above the fold — no scrolling needed to be noticed",
        "Exclusive solo slot — not shared in bundle discounts",
        "Maximum brand visibility for your business",
      ],
    },
    pl_labels: { home_top: "Home top — premium leaderboard", home: "Home — leaderboard banner", browse: "Browse — strip banner", browse_bottom: "Browse bottom — strip banner", browse_sidebar: "Browse — sidebar box", listing: "Listing detail — rectangle" },
    pl_name: { home_top: "Home top", home: "Home", browse: "Browse", browse_bottom: "Browse bottom", browse_sidebar: "Browse sidebar", listing: "Listing" },
    load: { open: "Open — great rotation", moderate: "Moderate", busy: "Busy" },
    status: { live: "Live", scheduled: "Scheduled", expired: "Expired", paused: "Paused", pending: "Pending review", rejected: "Rejected" },
    preview: {
      home_top: { title: "Home top — premium leaderboard", blurb: "A premium leaderboard banner at the very top of the homepage, above the featured listings — the first thing visitors see. Only shows when booked." },
      home: { title: "Home — leaderboard banner", blurb: "A wide leaderboard banner on the homepage, just below the featured listings — in front of everyone scrolling the front page." },
      browse: { title: "Browse — strip banner", blurb: "A slim strip banner on the Browse listings page, right above the results grid — seen by active shoppers filtering through pets and supplies." },
      browse_bottom: { title: "Browse bottom — strip banner", blurb: "A strip banner at the very bottom of the Browse listings page, below the results grid — catches shoppers who scrolled through every listing and are ready for a next step." },
      browse_sidebar: { title: "Browse — sidebar box", blurb: "A tall rectangle box in the Browse filters sidebar — persistently in view beside the results while shoppers browse pets and supplies." },
      listing: { title: "Listing detail — rectangle", blurb: "A rectangle box banner in the sidebar of every listing detail page, next to the seller contact box — high-intent viewers ready to make a decision." },
    },
  },
  fr: {
    signin: "Veuillez vous connecter pour annoncer.",
    gate_title: "Annoncer sur CritterPosts.ca",
    gate_body_1: "La publicité par bannière est réservée aux comptes ",
    gate_body_strong: "entreprise vérifiés",
    gate_body_2: ". Définissez votre type de compte sur Entreprise et faites-vous vérifier pour promouvoir votre marque auprès de milliers d'amoureux des animaux au Canada.",
    biz_account: "Compte entreprise",
    verified_seller: "Vendeur vérifié",
    go_dashboard: "Aller au tableau de bord",
    header_title: "Annoncez avec nous",
    header_sub_1: "Faites la promotion de votre entreprise dans des emplacements de bannières sur CritterPosts.ca. ",
    header_sub_price: (cur, rate) => `À partir de ${cur} ${rate}$/jour`,
    header_sub_2: " — payez par virement Interac.",
    submit_h: "Soumettre une bannière",
    ad_image: "Image de l'annonce",
    recommended_for: "Recommandé pour",
    uploading: "Téléversement…",
    upload_creative: "Téléversez votre visuel de bannière",
    cropped_note: (lbl, size) => `Recadrée au format ${lbl} (${size}). Utilisez « recadrer » si vous changez d'emplacement.`,
    headline: "Titre (superposition facultative)",
    headline_ph: "ex. 20 % de rabais sur le toilettage ce mois-ci",
    dest_link: "Lien de destination",
    dest_ph: "https://votreentreprise.ca ou /seller/votre-id",
    placement: "Emplacement",
    see_where: "Voir où elle apparaît :",
    full_guide: "Voir le guide complet des emplacements →",
    run_len: "Durée (jours)",
    save_longer: "Économisez sur les longues durées : 10 % dès 14 jours, 20 % dès 30 jours.",
    pref_start: "Date de début souhaitée (facultatif)",
    slot_avail: "Disponibilité des emplacements — choisissez un emplacement libre pour une rotation maximale",
    live_word: "en ligne",
    promo: "Code promo (facultatif)",
    promo_ph: "ex. SAVE25",
    apply: "Appliquer",
    coupon_applied: (code, d) => `✓ ${code} appliqué — ${d} % de rabais supplémentaire`,
    est_cost: "Coût estimé",
    off: "de rabais",
    code_suffix: "code",
    submit_btn: "Soumettre pour approbation",
    submit_bundle: "Soumettre le forfait pour approbation",
    bundle_label: "Emplacements du forfait",
    bundle_badge: (p) => `${p}% forfait`,
    bundle_hint: (n) => `Même bannière sur ${n} emplacements`,
    bundle_remove: "Retirer",
    receipt_placements: "Emplacements",
    t_bundle_loaded: (n) => `Forfait chargé — ajoutez un lien et réservez ${n} emplacements`,
    submit_note: "Après la soumission, envoyez le paiement par virement Interac. Votre annonce est mise en ligne dès que nous confirmons le paiement.",
    receipt_h: "Annonce soumise — paiement requis",
    receipt_body_1: "Envoyez un ",
    receipt_body_strong: "virement Interac",
    receipt_body_2: " pour finaliser votre réservation. Nous approuverons votre annonce dès réception du paiement.",
    send_to: "Envoyer à",
    amount: "Montant",
    msg_ref: "Message / référence",
    runs: "Diffusion",
    include_ref_1: "Indiquez la référence ",
    include_ref_2: " dans le message du virement pour que nous puissions associer votre paiement.",
    my_ads: "Mes annonces",
    weekly_email: "Courriel de performance hebdomadaire",
    no_ads: "Vous n'avez soumis aucune annonce pour le moment.",
    untitled: "(annonce sans titre)",
    download_report: "Télécharger le rapport",
    rerun: "Rediffuser",
    extend: "Prolonger",
    crop_for: (lbl, size) => `Recadrer pour ${lbl} — ${size}`,
    crop_desc: "Déplacez et zoomez pour que votre contenu clé remplisse le cadre. Votre image est enregistrée exactement au format de l'emplacement — aucun recadrage surprise.",
    cancel: "Annuler",
    apply_crop: "Appliquer le recadrage",
    where_appears: "Où elle apparaît",
    my_banner: "Ma bannière",
    upload_above: "Téléversez votre image ci-dessus et elle apparaîtra directement dans cet emplacement.",
    crop_warn_1: "Votre image fait ",
    crop_warn_2: " — elle sera recadrée au centre pour remplir cet emplacement. Gardez logos et textes dans la zone de sécurité en pointillés, ou téléversez ",
    crop_warn_3: " pour un ajustement parfait.",
    fit_ok: (size) => `Parfait — votre image correspond au format ${size} de cet emplacement. Gardez le contenu clé dans la zone de sécurité en pointillés.`,
    rec_size: "Taille d'image recommandée :",
    price_word: "Prix : ",
    per_day: "/jour",
    per_day_for: (cur, amt, days) => ` · ${cur} ${amt}$ pour ${days} jour${days === 1 ? "" : "s"}`,
    close: "Fermer",
    choose_placement: "Choisir cet emplacement",
    rerun_campaign: "Rediffuser la campagne",
    extend_campaign: "Prolonger la campagne",
    renew_desc: (title) => `Réservez une nouvelle diffusion de « ${title} ». Vous recevrez les instructions de virement Interac et elle sera en ligne dès confirmation du paiement.`,
    cost: "Coût",
    book_renewal: "Réserver le renouvellement",
    t_upload_img: "Veuillez choisir un fichier image",
    t_upload_first: "Téléversez d'abord l'image de votre annonce",
    t_add_link: "Ajoutez un lien de destination",
    t_renewal_booked: "Renouvellement réservé — envoyez le paiement pour la mise en ligne",
    t_code_applied: (d) => `Code appliqué — ${d} % de rabais`,
    t_code_invalid: "Ce code n'est pas valide",
    t_weekly_on: "Courriels hebdomadaires activés",
    t_weekly_off: "Courriels hebdomadaires désactivés",
    t_banner_loaded: "Votre bannière est chargée — ajoutez un lien et réservez",
    premium_badge: "Exclusif",
    scarcity: "Limité — un seul emplacement premium",
    fullpage_title: "Occupez toute la page de recherche",
    fullpage_body: (pct) => `Diffusez votre bannière sur les bandeaux du haut et du bas de la recherche et économisez ${pct} %.`,
    fullpage_btn: (pct) => `Forfait des deux bandeaux — ${pct} % de rabais`,
    preset_title: "Forfait & économies",
    preset_hint: "Réservez plusieurs emplacements ensemble et le rabais s'applique automatiquement.",
    preset_browse: "Les deux bandeaux recherche",
    preset_all: "Tous les emplacements",
    preset_save: (pct) => `−${pct} %`,
    combo_name: "Prise d'assaut accueil",
    combo_tag: "plein tarif",
    combo_badge: "Prise d'assaut accueil · plein tarif",
    premium_perks: {
      title: "Pourquoi choisir Premium",
      items: [
        "Tout en haut de la page d'accueil — la première chose que voient les visiteurs",
        "Au-dessus de la ligne de flottaison — visible sans défilement",
        "Emplacement exclusif et unique — hors des rabais de forfait",
        "Visibilité maximale pour votre marque",
      ],
    },
    pl_labels: { home_top: "Accueil (haut) — bandeau premium", home: "Accueil — bannière bandeau", browse: "Recherche — bannière horizontale", browse_bottom: "Recherche (bas) — bannière horizontale", browse_sidebar: "Recherche — encadré latéral", listing: "Fiche annonce — encadré" },
    pl_name: { home_top: "Accueil (haut)", home: "Accueil", browse: "Recherche", browse_bottom: "Recherche (bas)", browse_sidebar: "Encadré recherche", listing: "Fiche annonce" },
    load: { open: "Libre — excellente rotation", moderate: "Modéré", busy: "Chargé" },
    status: { live: "En ligne", scheduled: "Planifiée", expired: "Expirée", paused: "En pause", pending: "En attente de révision", rejected: "Rejetée" },
    preview: {
      home_top: { title: "Accueil (haut) — bandeau premium", blurb: "Une bannière bandeau premium tout en haut de la page d'accueil, au-dessus des annonces en vedette — la première chose que voient les visiteurs. Affichée uniquement lorsqu'elle est réservée." },
      home: { title: "Accueil — bannière bandeau", blurb: "Une large bannière sur la page d'accueil, juste sous les annonces en vedette — devant tous ceux qui parcourent la page d'accueil." },
      browse: { title: "Recherche — bannière horizontale", blurb: "Une bannière fine sur la page de recherche, juste au-dessus de la grille de résultats — vue par les acheteurs actifs qui filtrent animaux et articles." },
      browse_bottom: { title: "Recherche (bas) — bannière horizontale", blurb: "Une bannière horizontale tout en bas de la page de recherche, sous la grille de résultats — capte les acheteurs qui ont parcouru toutes les annonces et sont prêts pour la suite." },
      browse_sidebar: { title: "Recherche — encadré latéral", blurb: "Un grand encadré vertical dans la barre latérale des filtres — constamment visible à côté des résultats pendant la navigation." },
      listing: { title: "Fiche annonce — encadré", blurb: "Un encadré rectangulaire dans la barre latérale de chaque fiche d'annonce, à côté du bloc de contact du vendeur — des visiteurs prêts à décider." },
    },
  },
};
